import { Expose } from "class-transformer";

export class CreateDocumentationTypeDto {
  @Expose()
  name: string;
}
